import getCanvasHeight from './getCanvasHeight';

const initCanvas = ({
  canvasRef,
  camera,
}: {
  canvasRef: any;
  camera: any;
}): any => {
  const renderer = new THREE.WebGLRenderer({
    alpha: true,
    antialias: true,
    canvas: canvasRef.current,
  });

  const onWindowResize = () => {
    const height = getCanvasHeight();
    camera.aspect = window.innerWidth / height;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, height);
  };

  window.addEventListener('resize', onWindowResize, false);

  const loader = new THREE.FontLoader();
  loader.load('/Fonts/Arial Narrow_Regular.json', (response: any) => {
    window.SetFont(response);
  });

  return renderer;
};

export default initCanvas;
